import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { ReviewsSection } from 'components/Accommodation/ReviewsSection';
import { GuestReviewLayout } from 'components/Accommodation/ReviewsSection/constants';
import { getReviewAvailability } from 'components/Accommodation/ReviewsSection/utils';
import { Divider } from '@daedalus/atlas/Divider';
import { ContentHotel } from '@findhotel/sapi';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w8qvwdi",
  propsAsIs: false
});
interface Props {
  hotel: ContentHotel;
  reviewsRef?: React.RefObject<HTMLDivElement>;
  layoutConfig?: GuestReviewLayout;
  mountedOnOverlay?: boolean;
}
export const ConditionalReviews = ({
  hotel,
  reviewsRef,
  layoutConfig = GuestReviewLayout.DEFAULT,
  mountedOnOverlay = false
}: Props) => {
  const {
    hasAnyReviewComponent
  } = getReviewAvailability(hotel);
  const shouldRenderReviews = !hotel || hasAnyReviewComponent;
  if (!shouldRenderReviews) return null;
  return <>
      {mountedOnOverlay ? null : <Divider sideMargin="s500" />}
      <>
        <Wrapper className={cx(mountedOnOverlay && '__mountedOnOverlay')}>
          <ReviewsSection anchorRef={reviewsRef} hotel={hotel} layoutConfig={layoutConfig} mountedOnOverlay={mountedOnOverlay} />
        </Wrapper>
      </>
    </>;
};

require("./ConditionalReviews.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ConditionalReviews.tsx");